import { useMemo, useState } from "react";
import { Helmet } from "react-helmet";
import Navigation from "@/components/Navigation";
import { Card } from "@/components/ui/card";
import HoroscopeContent from "@/components/HoroscopeContent";

const Horoscope = () => {
  const zodiacSigns = useMemo(
    () => [
      { id: "aries", name: "Aries", emoji: "♈", dates: "Mar 21 - Abr 19" },
      { id: "tauro", name: "Tauro", emoji: "♉", dates: "Abr 20 - May 20" },
      { id: "geminis", name: "Géminis", emoji: "♊", dates: "May 21 - Jun 20" },
      { id: "cancer", name: "Cáncer", emoji: "♋", dates: "Jun 21 - Jul 22" },
      { id: "leo", name: "Leo", emoji: "♌", dates: "Jul 23 - Ago 22" },
      { id: "virgo", name: "Virgo", emoji: "♍", dates: "Ago 23 - Sep 22" },
      { id: "libra", name: "Libra", emoji: "♎", dates: "Sep 23 - Oct 22" },
      { id: "escorpio", name: "Escorpio", emoji: "♏", dates: "Oct 23 - Nov 21" },
      { id: "sagitario", name: "Sagitario", emoji: "♐", dates: "Nov 22 - Dic 21" },
      { id: "capricornio", name: "Capricornio", emoji: "♑", dates: "Dic 22 - Ene 19" },
      { id: "acuario", name: "Acuario", emoji: "♒", dates: "Ene 20 - Feb 18" },
      { id: "piscis", name: "Piscis", emoji: "♓", dates: "Feb 19 - Mar 20" },
    ],
    []
  );

  const [selectedSign, setSelectedSign] = useState("aries");
  const selected = zodiacSigns.find((s) => s.id === selectedSign) ?? zodiacSigns[0];

  return (
    <>
      <Helmet>
        <title>Horóscopo Occidental: Diario, Semanal y Mensual</title>
        <meta
          name="description"
          content="Explora el horóscopo occidental con predicciones diarias, semanales y mensuales para los 12 signos zodiacales." 
        />
        <link rel="canonical" href={`${window.location.origin}/horoscopo`} />
      </Helmet>

      <div className="min-h-screen">
        <Navigation />

        <main className="pt-24 pb-12 px-4">
          <div className="container mx-auto">
            <header className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold mb-4 text-glow">Horóscopo Occidental</h1>
              <p className="text-center text-lg md:text-xl text-muted-foreground">
                Predicciones diarias, semanales y mensuales para los 12 signos zodiacales
              </p>
            </header>

            <section aria-label="Selecciona tu signo" className="mb-12">
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                {zodiacSigns.map((sign) => (
                  <Card
                    key={sign.id}
                    onClick={() => setSelectedSign(sign.id)}
                    className={`p-4 text-center cursor-pointer transition-all duration-300 ${
                      selectedSign === sign.id
                        ? "card-glow bg-primary/20 border-primary"
                        : "hover:bg-card/80"
                    }`}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") setSelectedSign(sign.id);
                    }}
                    aria-pressed={selectedSign === sign.id}
                  >
                    <div className="text-4xl mb-2" aria-hidden="true">
                      {sign.emoji}
                    </div>
                    <h2 className="font-bold">{sign.name}</h2>
                    <p className="text-xs text-muted-foreground">{sign.dates}</p>
                  </Card>
                ))}
              </div>
            </section>

            <section aria-label={`Horóscopo completo de ${selected.name}`} className="max-w-4xl mx-auto">
              <div className="mb-6 text-center">
                <h2 className="text-3xl font-bold mb-2 flex items-center justify-center gap-3">
                  <span className="text-4xl" aria-hidden="true">
                    {selected.emoji}
                  </span>
                  {selected.name}
                </h2>
                <p className="text-muted-foreground">{selected.dates}</p>
              </div>

              <HoroscopeContent sign={selected.id} signName={selected.name} />
            </section>
          </div>
        </main>
      </div>
    </>
  );
};

export default Horoscope;
